/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import CQContainer from '../../components/layout/CQContainer';
import { withProvider } from '../../hoc/withProvider';
import { FONT_FAMILY } from '../../constants/Theme';
import TeamProvider, { TeamContext } from '../../providers/TeamProvider';
import { Text } from '@chakra-ui/react';
import TeamForm from './components/TeamForm';
import { EDIT_MODE } from '../../constants/constants';
import { useParams } from 'react-router-dom';

const TeamEditFormContainer = props => {
  const { teamId } = useParams();
  const { getSpecialties } = useContext(TeamContext);
  useEffect(() => {
    const getSpecialtiesData = async () => {
      await getSpecialties();
    };
    getSpecialtiesData();
  }, []);
  return (
    <>
      <CQContainer py={30} px={30} pb={20}>
        <Text
          fontFamily={FONT_FAMILY.baiJamurjee}
          fontWeight="bold"
          fontSize={22}
        >
          Edit Team
        </Text>
        <Box
          bg="white"
          p={4}
          pb={20}
          w="100%"
          h="150%"
          borderRadius="md"
          ml={0}
          mt={3}
        >
          <TeamForm mode={EDIT_MODE} teamId={teamId} />
        </Box>
      </CQContainer>
    </>
  );
};

export default withProvider(TeamProvider, TeamEditFormContainer);
